export const companyDetails = {
  name: "PALAMAR TEKNOLOJİ ANONİM ŞİRKETİ",
  brand: "Palmate",
  address: "SANAYİ MAH. TEKNOPARK BLV. NO: 1 /10C İÇ KAPI NO: Z42 PENDİK / İSTANBUL",
  taxOffice: "PENDİK",
  taxNumber: "7201096983",
  mersisNumber: "0720109698300001",
  kepEmail: "palamarteknoloji@hs01.kep.tr",
  chamberName: "İstanbul Ticaret Odası",
  chamberUrl: "https://www.ito.org.tr/tr/",
  chamberRegulationsUrl: "https://www.ito.org.tr/tr/kurumsal/oda-mevzuati",
  email: "info@palmate.ai",
};

export const companyPhone = {
  display: "+90 216 706 77 67",
  number: "+902167067767",
  href: "tel:+902167067767",
};

export const companySocialLinks = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/palmateai" },
  { label: "X", href: "https://x.com/palmateai" },
  { label: "Instagram", href: "https://www.instagram.com/palmate.ai/" },
  { label: "WhatsApp", href: "https://wa.me/902167067767" },
];


